import { id, init } from "@instantdb/core";

const APP_ID = "ae277e03-2e12-48ae-bc71-7bfcfe6dcdcc";
const WAIVER_VERSION = "1.3.0";

const db = init({ appId: APP_ID });

const dataUrlToFile = async (
	dataUrl: string,
	filename: string,
): Promise<File> => {
	const res = await fetch(dataUrl);
	const blob = await res.blob();
	return new File([blob], filename, { type: blob.type });
};

document.addEventListener("DOMContentLoaded", () => {
	const form = document.getElementById("waiver-form") as HTMLFormElement | null;
	const logo = document.getElementById("logo") as HTMLImageElement | null;
	const sig = document.getElementById("signature") as HTMLElement | null;
	const resetSigCanvas = document.getElementById(
		"clearSig",
	) as HTMLButtonElement | null;
	const messageDiv = document.getElementById("form-message");
	const waiverTitle = document.getElementById("waiver-title");

	// @ts-ignore
	const component = Signature(sig, {
		width: window.innerWidth < 600 ? window.innerWidth - 24 : 500,
		height: 100,
		instructions: "Please sign in the box above",
	});

	resetSigCanvas?.addEventListener("click", () => {
		component.value = [];
	});

	// Form submission
	form?.addEventListener("submit", async (e) => {
		e.preventDefault();

		if (!component.value.length) {
			alert("Please sign in the signature box.");
			return;
		}

		const submitButton = form.querySelector(
			'button[type="submit"]',
		) as HTMLButtonElement | null;
		if (submitButton) {
			submitButton.disabled = true;
			submitButton.textContent = "Submitting...";
		}

		try {
			const waiverId = id();
			// Convert the signature bytes to a file
			const file = await dataUrlToFile(component.getImage(), `${waiverId}.png`);
			if (file) {
				const uploadRes = await db.storage.uploadFile(file.name, file, {
					contentType: file.type,
					contentDisposition: "attachment",
				});
				if (!uploadRes) throw new Error("Failed to upload signature");

				const formData = new FormData(form);

				const data = {
					first_name: formData.get("first_name") as string,
					last_name: formData.get("last_name") as string,
					email: formData.get("email") as string,
					phone: formData.get("phone") as string,
					address: formData.get("address") as string,
					city: formData.get("city") as string,
					state: formData.get("state") as string,
					zip: formData.get("zip") as string,
					emergency_contact_name: formData.get(
						"emergency_contact_name",
					) as string,
					emergency_contact_phone: formData.get(
						"emergency_contact_phone",
					) as string,
					waiver_version: WAIVER_VERSION,
					axis_updates: (formData.get("axis_updates") as string) === "on",
					createdAt: new Date().toISOString(),
				};

				const submitRes = await db.transact(
					db.tx.waivers[waiverId]
						.update(data)
						.link({ $files: uploadRes.data.id }),
				);

				const isSyncedToInstant = submitRes.status === "synced";

				// Send to Google Sheets too
				const res = await fetch("/api/submit-form", {
					method: "POST",
					body: JSON.stringify({ ...data, signature_url: "" }),
					headers: { "Content-Type": "application/json" },
				});

				const json = await res.json();
				const isSyncedToGoogle = json.status === "success";

				if (isSyncedToInstant && isSyncedToGoogle) {
					waiverTitle!.innerHTML = "Thank you!";
					messageDiv!.innerHTML = `<p>Your waiver has been submitted.</p>`;
					form.style.display = "none";
					messageDiv!.classList.remove("error");
				} else {
					throw new Error("Submission not synced");
				}
			}
		} catch (error) {
			console.error(error);
			messageDiv!.innerHTML = `<p>There was a problem submitting your waiver. Please try again.</p>`;
			messageDiv!.classList.add("error");
		} finally {
			if (submitButton) {
				submitButton.disabled = false;
				submitButton.textContent = "Submit Waiver";
			}

			logo?.addEventListener("click", () => {
				window.location.reload();
			});
		}
	});
});

// Notes:
// Uses https://lemonadejs.com/docs/plugins/signature to create a signature image
